import { Flex, Select, SelectProps, Typography } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '@eastcoal/editor/Store/hooks/useStore'

import { FontSizeSelectProps } from './interface'

const optionRender: SelectProps['optionRender'] = ({ label, value }) => {
  return (
    <Flex align='center' gap={0} justify='center'>
      <span>{label}</span>
      <Typography.Text type='secondary'>（{value}）</Typography.Text>
    </Flex>
  )
}

export const FontSizeSelect = (props: FontSizeSelectProps) => {
  const { fontSizeList, defaultFontSize } = useRichEditorStore(state =>
    pick(state, ['fontSizeList', 'defaultFontSize'])
  )

  return (
    <Select
      {...props}
      defaultValue={defaultFontSize}
      optionRender={optionRender}
      options={fontSizeList}
    />
  )
}
